import { Component, OnDestroy, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { AppState } from '../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../auth/auth.service';
import { UserModel } from '../../auth/models/user.model';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { UIRouter, Transition, StateDeclaration } from '@uirouter/core';
import { ButtonsService } from '../../buttons/buttons.service';
import { CheckoutService } from '../../checkout/checkout.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'jb-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.scss'
  ],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }]
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  public showSocialButtonsOverlay: boolean = false;
  private isTouchDevice: any;
  private userSub: Subscription;
  private stateSub: Subscription;

  private backRedirectTo: string = null;
  private code: string = null;

  private lightElements: HTMLCollectionOf<HTMLElement>;
  private sectionElements: HTMLCollectionOf<HTMLElement>;

  private onScroll = (event: Event) => {
    this.determineBackground();
    this.determineCurrentAnchor();
  }

  public currentAnchor: string = null;

  public isOnLightBackground: boolean = false;

  public hideBackButton: boolean = false;
  public hidePlayButton: boolean = true;
  public hideCheckoutButton: boolean = false;

  public isMenuActive: boolean = false;
  public isForgotPasswordActive: boolean = false;

  public currentUser: UserModel = null;

  public countButtons: number = 0;

  public loginData = {
    email: null,
    password: null
  };

  public loginErrors = {
    wrongPassword: false,
    wrongEmail: false,
    failed: false
  };

  public loginReturnTo: string;

  public forgotPasswordSuccess: boolean = false;

  public forgotPasswordData = {
    email: null
  };

  public forgotPasswordErrors = {
    wrongEmail: false,
    failed: false
  };

  @ViewChild('menuButtonElement')
  public menuButtonElement: ElementRef;

  constructor(
    private appState: AppState,
    private router: UIRouter,
    private authService: AuthService,
    private location: Location,
    private buttonsService: ButtonsService,
    private checkoutService: CheckoutService
  ) {
  }

  private determineBackground() {
    if (this.lightElements) {
      const headerTopPosition = window.document.documentElement.scrollTop +
        this.menuButtonElement.nativeElement.offsetTop -
        this.menuButtonElement.nativeElement.scrollTop +
        this.menuButtonElement.nativeElement.clientTop;

      this.isOnLightBackground = false;

      // tslint:disable
      for (let i = 0; i < this.lightElements.length; i++) {
        // tslint:enable
        const elementTopPosition = this.lightElements[i].offsetTop -
          this.lightElements[i].scrollTop +
          this.lightElements[i].clientTop;

        const elementBottomPosition = elementTopPosition + this.lightElements[i].offsetHeight;

        if (headerTopPosition > elementTopPosition && headerTopPosition < elementBottomPosition) {
          setTimeout(() => {
            this.currentAnchor = this.lightElements[i].id;
          }, 0);

          if (this.lightElements[i].classList.contains('light-background')) {
            this.isOnLightBackground = true;
          }

          break;
        }
      }
    }
  }

  private determineCurrentAnchor() {
    if (this.sectionElements) {
      const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      const windowTopPosition = window.document.documentElement.scrollTop;
      const windowBottomPosition = window.document.documentElement.scrollTop + windowHeight;

      let currentAnchor = null;

      // tslint:disable
      for (let i = 0; i < this.sectionElements.length; i++) {
        // tslint:enable
        const elementTopPosition = this.sectionElements[i].offsetTop -
          this.sectionElements[i].scrollTop +
          this.sectionElements[i].clientTop;

        const elementBottomPosition = elementTopPosition + this.sectionElements[i].offsetHeight;

        if (
          elementTopPosition - windowHeight / 2 < windowTopPosition &&
          elementBottomPosition + windowHeight / 2 > windowBottomPosition
        ) {
          currentAnchor = this.sectionElements[i].id;

          break;
        }
      }

      setTimeout(() => {
        this.currentAnchor = currentAnchor;
      }, 0);
    }
  }

  private processHeaderOptions(state: StateDeclaration) {
    if (state.params && state.params.header) {
      this.backRedirectTo = state.params.header.backTo ? state.params.header.backTo : null;

      this.hideBackButton = typeof (state.params.header.hideBackButton) !== 'undefined' ?
        state.params.header.hideBackButton :
        this.hideBackButton;

      this.hidePlayButton = typeof (state.params.header.hidePlayButton) !== 'undefined' ?
        state.params.header.hidePlayButton :
        this.hidePlayButton;

      this.hideCheckoutButton = typeof (state.params.header.hideCheckoutButton) !== 'undefined' ?
        state.params.header.hideCheckoutButton :
        this.hideCheckoutButton;
        
      this.code = typeof state.params.code !== 'undefined' ? state.params.code : null;
    } else {
      this.backRedirectTo = null;
      this.hideBackButton = false;
      this.hidePlayButton = true;
      this.code = null;
    }
  }

  private clearLogin() {
    this.loginReturnTo = null;
  }

  public ngOnInit() {
    let deviceAgent = navigator.userAgent.toLowerCase();
    
    this.isTouchDevice = (deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/)  || 
      deviceAgent.match(/(iemobile)/) || 
      deviceAgent.match(/iphone/i) || 
      deviceAgent.match(/ipad/i) || 
      deviceAgent.match(/ipod/i) || 
      deviceAgent.match(/blackberry/i) || 
      deviceAgent.match(/bada/i)
    );
    
    this.stateSub = this.appState.change.subscribe((change) => {
      if (change.property === 'isMenuActive') {
        this.isMenuActive = change.newValue;

        if (!this.isMenuActive) {
          this.clearLogin();
        } else {
          let mail = this.authService.getPrefillEmail();
          
          if (mail !== false) {
            this.loginData.email = mail;
          }
        }
      }
    });

    this.isMenuActive = this.appState.get('isMenuActive');
    
    if (this.isMenuActive) {
      let mail = this.authService.getPrefillEmail();
      
      if (mail !== false) {
        this.loginData.email = mail;
      }
    }

    this.currentUser = this.authService.currentUser;

    this.userSub = this.authService.currentUserChange
      .subscribe(
        (user) => {
          this.currentUser = user;
        }
      );

    this.processHeaderOptions(this.router.stateService.current);

    this.router.transitionService.onSuccess(
      {},
      (transition: Transition) => {
        this.currentAnchor = null;

        const to = transition.to();

        this.processHeaderOptions(to);
      }
    );

    /* this.countButtons = this.checkoutService.items.length;

    this.checkoutService.itemsChange.subscribe(
      (items) => {
        this.countButtons = items.length;
      }
    ); */

    this.authService.currentUserChange.subscribe(
      (result) => {
        if (result) {
          this.buttonsService.getMine()
            .subscribe(
              (results) => {
                this.countButtons = results.length;
              }
            );
        } else {
          this.countButtons = 0;
        }
      }
    );

    if (this.authService.currentUser) {
      this.buttonsService.getMine()
        .subscribe(
          (results) => {
            this.countButtons = results.length;
          }
        );
    }
  }

  public ngAfterViewInit() {
    this.lightElements = window.document.getElementsByClassName('light-background') as HTMLCollectionOf<HTMLElement>;
    this.sectionElements = window.document.getElementsByClassName('section') as HTMLCollectionOf<HTMLElement>;

    setTimeout(() => {
      this.determineBackground();
    }, 0);
    
    this.determineCurrentAnchor();

    window.addEventListener('scroll', this.onScroll);
  }

  public ngOnDestroy(): void {
    this.stateSub.unsubscribe();
    this.userSub.unsubscribe();

    window.removeEventListener('scroll', this.onScroll);
  }

  public toggleMenu() {
    this.appState.set('isMenuActive', !this.isMenuActive);
  }
  
  public closeMenu() {
    this.appState.set('isMenuActive', false);
  }

  public handleLogin() {
    if (this.loginData.email && this.loginData.password) {
      this.loginErrors = {
        wrongPassword: false,
        wrongEmail: false,
        failed: false
      };

      this.authService.login(this.loginData.email, this.loginData.password)
        .subscribe(
          (result) => {
            if (this.loginReturnTo) {
              this.router.stateService.go(this.loginReturnTo);

              this.clearLogin();
            }
          },
          (err) => {
            if (err.code === 'NotAuthorizedException') {
              this.loginErrors.wrongPassword = true;
            } else if (err.code === 'UserNotFoundException') {
              this.loginErrors.wrongEmail = true;
            } else {
              this.loginErrors.failed = true;
            }
          }
        );
    }
  }

  public requestLogin(returnTo: string) {
    this.appState.set('isMenuActive', true);

    this.loginReturnTo = returnTo;
  }

  public resetForgotPasswordMessages() {
    this.forgotPasswordErrors = {
      wrongEmail: false,
      failed: false
    };

    this.forgotPasswordSuccess = false;
  }

  public handleForgotPassword(form: NgForm) {
    if (form.valid) {
      this.resetForgotPasswordMessages();

      this.authService.forgotPassword(this.forgotPasswordData.email)
        .subscribe(
          (result) => {
            this.forgotPasswordSuccess = true;

            this.isForgotPasswordActive = false;
          },
          (err) => {
            if (err.code === 'UserNotFoundException') {
              this.forgotPasswordErrors.wrongEmail = true;
            } else {
              this.forgotPasswordErrors.failed = true;
            }
          }
        );
    }
  }

  public handleLogout() {
    this.authService.logout();
  }

  public activateForgotPassword() {
    this.isForgotPasswordActive = true;
  }
  public deactivateForgotPassword() {
    this.resetForgotPasswordMessages();

    this.isForgotPasswordActive = false;
  }

  public handleBack() {
    if (this.backRedirectTo && this.backRedirectTo === 'index') {
      this.router.stateService.go('main.home');
    } else if (this.backRedirectTo && this.backRedirectTo !== '' && this.backRedirectTo !== null) {
      this.router.stateService.go(this.backRedirectTo, { code: this.code });
    } else {
      this.location.back();
    }
  }

  public handleMyButtons() {
    this.appState.set('isMenuActive', false);

    this.router.stateService.go('main.buttons.my');
  }

  public activateVideoModal() {
    this.appState.set('isVideoModalActive', true);
  }
  
  public toggleSocialButtonsOverlay(evt) {
    let evtType = evt.type;
    
    switch (evtType) {
      case 'mouseenter':
        if (this.isTouchDevice) {
          return false;
        }
        
        this.showSocialButtonsOverlay = true;
        
        break;
      case 'mouseleave':
        if (this.isTouchDevice) {
          return false;
        }
        
        this.showSocialButtonsOverlay = false;
      
        break;
      case 'click':
        if (!this.isTouchDevice) {
          return false;
        }
        
        this.showSocialButtonsOverlay = !this.showSocialButtonsOverlay;
      
        break;
      default:
        break;
    }
  }
  
  public getDataToShare() {
    return {
      image: '/assets/img/share/home/mzp.jpg',
      title: 'Mut zur Phantasie',
      copy: 'Mit einem Knopf die Welt verändern. Mit Mut zut Phantasie. Werde Teil der Geschichte unter: www.mutzurphantasie.de',
      linkToShare: 'https://pk7napwge5.execute-api.eu-central-1.amazonaws.com/stg/html/button/'
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/global/header/header.component.ts